module.exports = "/img/AIError.b47e41be.png";